import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardMenuFlowQuantity = createSelector(wizzardState, (wizzard) => (wizzard.itemsMenuFlow ? wizzard.itemsMenuFlow.Quantity : null));
